import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';
import { Expose, Type } from 'class-transformer';
import { TFA } from './tfa.model';
import { Router } from '@angular/router';
import { Role } from './role.model';

export class User extends BaseModel {
  @Expose()
  id: number;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  email: string;

  @Expose()
  phone: string;

  @Expose()
  avatar: string;

  @Expose()
  avatarType: string;

  password?: string;

  @Expose()
  resetToken: string;

  @Expose()
  description: string;

  @Expose()
  roles: Role[];

  @Expose()
  @Type(() => Address)
  address: Address;

  @Expose()
  @Type(() => TFA)
  tfa: TFA;

  get fullname() {
    return `${this.firstName} ${this.lastName}`;
  }

  clear(): void {
    this.id = undefined;
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.avatar = '';
    this.avatarType = '';
    this.password = '';
    this.resetToken = '';
    this.description = '';
    this.roles = [];
    this.address = new Address();
    this.address.clear();
    this.tfa = new TFA();
    this.tfa.clear();
  }
}
